import script from "./ResourceRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceRow.vue?vue&type=script&setup=true&lang=ts"

import "./ResourceRow.vue?vue&type=style&index=0&id=e4087d5e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4087d5e"]])

export default __exports__